<template>
  <div>
    <v-card class="px-3 pt-1 pb-3">
      <div class="text-xs-right">
        <v-btn fab flat left @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div>
        <div
          class="mb-2"
          :style="{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }"
        >
          <v-btn icon class="ma-0" @click="editing = true">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn icon class="ma-0" @click="viewingEditHistory = true">
            <v-icon>history</v-icon>
          </v-btn>
        </div>
        <template v-if="memberDetail">
          <v-card class="bg-profile-card pa-3" max-width="1000px">
            <v-layout wrap>
              <v-flex xs3 class="align-center" style="display: flex">
                <v-avatar :tile="false" size="128px" color="grey lighten-4">
                  <img :src="memberDetail.profile_pic" alt="avatar" />
                </v-avatar>
              </v-flex>
              <v-flex xs9>
                <div class="primary--text">{{ memberDetail.full_name }}</div>
                <div class="mt-3">
                  <span class="font-weight-bold"> ประเภทบัญชี :</span>
                  {{ getMemberTypeText(memberDetail.member_type) }}
                </div>
                <div>
                  <span class="font-weight-bold">เบอร์โทรศัพท์ :</span>
                  {{ memberDetail.identity_card_no || '-' }}
                </div>
                <div>
                  <span class="font-weight-bold">โครงการ / หมู่บ้าน :</span>
                  {{ memberDetail.project || '-' }}
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </template>
      </div>
      <div v-if="memberDetail">
        <v-data-table
          :headers="headers"
          :items="assetList"
          class="elevation-1 mt-3"
          :pagination.sync="pagination"
        >
          <template #items="props">
            <tr>
              <td>{{ props.item.asset_no || '-' }}</td>
              <td>{{ props.item.asset_name || '-' }}</td>
              <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY hh:mm A') }}</td>
              <td class="text-xs-center">
                <span v-if="props.item.status" class="green--text">เปิด</span>
                <span v-else class="red--text">ปิด</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <MemberEditDialog v-model="editing" :value="value" @submitted="handleMemberEditSubmitted" />
    <MemberEditHistoryDialog v-model="viewingEditHistory" :value="value" />
  </div>
</template>

<script>
import MemberEditDialog from './MemberEditDialog.vue'
import MemberEditHistoryDialog from './MemberEditHistoryDialog.vue'
import { MEMBER_TYPE_OPTIONS } from '@/constants/juzmatch'

export default {
  components: {
    MemberEditDialog,
    MemberEditHistoryDialog
  },
  props: ['value'],
  data() {
    return {
      memberDetail: null,
      pagination: { sortBy: 'none', descending: false, rowsPerPage: 10 },
      headers: [
        { text: 'รหัสทรัพย์', value: 'asset_no', sortable: false },
        { text: 'ชื่อทรัพย์', value: 'asset_name', sortable: false },
        { text: 'วันที่เพิ่ม', value: 'timestamp', sortable: false },
        { text: 'การแจ้งเตือนค่างวด', value: 'status', sortable: false, align: 'center' }
      ],
      editing: false,
      viewingEditHistory: false
    }
  },
  computed: {
    assetList() {
      return this.memberDetail.assets || []
    }
  },
  mounted() {
    if (this.value) {
      this.memberDetail = this.value
    }
  },
  methods: {
    getMemberTypeText(type) {
      const found = MEMBER_TYPE_OPTIONS.map((option) => ({
        ...option,
        text: this.$t(`juzmatch_member_type.${option.text}`)
      })).find((option) => option.value === type)
      return found ? found.text : '-'
    },
    handleMemberEditSubmitted(value) {
      this.memberDetail = value
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberDetailDialog.vue